import makeSlice from '@web/slices/card/sliceMaker'

const cardSlice = makeSlice({})

export default cardSlice.reducer
